import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const MoneyBagFilled = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M8.36 6.94h7.32l.78-1.33c.59-1.01.01-2.43-.99-2.43H8.56c-1.01 0-1.58 1.44-.98 2.44l.79 1.31-.01.01ZM19.3 13.71l-3.53-5.63H8.35l-3.53 5.63c-1.98 3.15.46 7.11 4.37 7.11h5.73c3.91 0 6.34-3.96 4.37-7.11h.01Zm-4.92-1.86h-1.61c.36.27.58.64.66 1.07h.95v.66h-.94c-.12.96-.82 1.49-1.54 1.61l1.61 2.59h-1.34l-1.47-2.46H9.62V14.3h1.51c.52 0 .93-.28 1.08-.72H9.62v-.66h2.6c-.13-.46-.54-.71-1.09-.71H9.62v-1.02h4.75v.66h.01Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default MoneyBagFilled
